import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../servicos/firebase';

const barbers = [
    { id: '1', name: 'Carlos Silva', image: '/imagens/fotobarber.PNG' },
    { id: '2', name: 'André Santos', image: '/imagens/fotobarber.PNG' },
    { id: '3', name: 'Marcos Oliveira', image: '/imagens/fotobarber.PNG' }
];

const services = [
    { id: '1', name: 'Corte Social', price: 'R$ 45,00', duration: '1h', category: 'Cabelo' },
    { id: '2', name: 'Degradê Moderno', price: 'R$ 55,00', duration: '45 min', category: 'Cabelo' },
    { id: '3', name: 'Corte Navalhado', price: 'R$ 60,00', duration: '1h', category: 'Cabelo' },
    { id: '12', name: 'Corte Infantil', price: 'R$ 40,00', duration: '1h', category: 'Cabelo' },
    { id: '29', name: 'Pezinho', price: 'R$ 20,00', duration: '15 min', category: 'Cabelo' },
    { id: '30', name: 'Raspado (Máquina)', price: 'R$ 30,00', duration: '20 min', category: 'Cabelo' },
    { id: '31', name: 'Moicano Moderno', price: 'R$ 60,00', duration: '50 min', category: 'Cabelo' },
    { id: '32', name: 'Mullet Hair', price: 'R$ 65,00', duration: '55 min', category: 'Cabelo' },
    { id: '36', name: 'Pompadour', price: 'R$ 65,00', duration: '1h', category: 'Cabelo' },
    { id: '37', name: 'Flat Top', price: 'R$ 70,00', duration: '1h', category: 'Cabelo' },
    { id: '4', name: 'Barba Simples', price: 'R$ 35,00', duration: '20 min', category: 'Barba' },
    { id: '5', name: 'Barboterapia', price: 'R$ 50,00', duration: '40 min', category: 'Barba' },
    { id: '6', name: 'Design de Barba', price: 'R$ 45,00', duration: '1h', category: 'Barba' },
    { id: '35', name: 'Grooming Barba', price: 'R$ 40,00', duration: '25 min', category: 'Barba' },
    { id: '40', name: 'Barba de Respeito', price: 'R$ 55,00', duration: '40 min', category: 'Barba' },
    { id: '13', name: 'Combo (Corte + Barba)', price: 'R$ 85,00', duration: '1h 15min', category: 'Combos' },
    { id: '14', name: 'Corte + Sobrancelha', price: 'R$ 65,00', duration: '1h', category: 'Combos' },
    { id: '25', name: 'Combo Premium', price: 'R$ 180,00', duration: '2h 30min', category: 'Combos' },
    { id: '26', name: 'Dia do Noivo (Básico)', price: 'R$ 250,00', duration: '3h', category: 'Combos' },
    { id: '38', name: 'Corte + Tintura', price: 'R$ 110,00', duration: '1h 30min', category: 'Combos' },
    { id: '7', name: 'Sobrancelha (Navalha)', price: 'R$ 20,00', duration: '15 min', category: 'SPA & Química' },
    { id: '8', name: 'Limpeza de Pele', price: 'R$ 40,00', duration: '1h', category: 'SPA & Química' },
    { id: '9', name: 'Máscara Negra', price: 'R$ 25,00', duration: '20 min', category: 'SPA & Química' },
    { id: '10', name: 'Pigmentação Cabelo', price: 'R$ 40,00', duration: '40 min', category: 'SPA & Química' },
    { id: '11', name: 'Pigmentação Barba', price: 'R$ 30,00', duration: '1h', category: 'SPA & Química' },
    { id: '15', name: 'Reflexo Alinhado', price: 'R$ 90,00', duration: '1h 30min', category: 'SPA & Química' },
    { id: '16', name: 'Luzes', price: 'R$ 80,00', duration: '1h 20min', category: 'SPA & Química' },
    { id: '17', name: 'Platinado Global', price: 'R$ 150,00', duration: '2h 30min', category: 'SPA & Química' },
    { id: '18', name: 'Relaxamento', price: 'R$ 70,00', duration: '1h', category: 'SPA & Química' },
    { id: '19', name: 'Progressiva', price: 'R$ 120,00', duration: '1h 30min', category: 'SPA & Química' },
    { id: '20', name: 'Selagem', price: 'R$ 100,00', duration: '1h 20min', category: 'SPA & Química' },
    { id: '21', name: 'Hidratação Capilar', price: 'R$ 35,00', duration: '1h', category: 'SPA & Química' },
    { id: '22', name: 'Lavagem Especial', price: 'R$ 15,00', duration: '10 min', category: 'SPA & Química' },
    { id: '23', name: 'Depilação Nariz', price: 'R$ 20,00', duration: '15 min', category: 'SPA & Química' },
    { id: '24', name: 'Depilação Orelha', price: 'R$ 20,00', duration: '15 min', category: 'SPA & Química' },
    { id: '27', name: 'Camuflagem Brancos', price: 'R$ 50,00', duration: '1h', category: 'SPA & Química' },
    { id: '28', name: 'Esfoliação Facial', price: 'R$ 30,00', duration: '20 min', category: 'SPA & Química' },
    { id: '33', name: 'Tônico Capilar', price: 'R$ 15,00', duration: '5 min', category: 'SPA & Química' },
    { id: '34', name: 'Massagem Relaxante', price: 'R$ 50,00', duration: '1h', category: 'SPA & Química' },
    { id: '39', name: 'Nutrição Facial', price: 'R$ 45,00', duration: '1h', category: 'SPA & Química' }
];

const config = {
    address: "Rua Exemplo, 123 - Centro, Uberlândia - MG",
    hours: [
        { label: "Seg a Sex", period: "08h — 20h" },
        { label: "Sábados", period: "08h — 18h" }
    ],
    mapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.2081744155825!2d-48.27552!3d-18.9185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDU1J_zA2LjYiUyA0OMKwMTYnMzEuOSJX!5e0!3m2!1spt-BR!2sbr!4v1620000000000!5m2!1spt-BR!2sbr"
};

export const seedDatabase = async (barbershopId, force = false) => {
    if (!barbershopId) {
        console.error("Tentativa de seed sem barbershopId abortada.");
        return;
    }

    try {
        console.log(force ? `Iniciando restauração FORÇADA de dados para ${barbershopId}...` : `Iniciando sincronização de dados para ${barbershopId}...`);

        // Seed Barbers
        for (const barber of barbers) {
            // Use composite ID to avoid tenant collisions
            const barberDocId = `${barber.id}_${barbershopId}`;
            const barberRef = doc(db, "barbers", barberDocId);
            const barberData = { ...barber, id: barberDocId, barbershopId };

            if (force) {
                await setDoc(barberRef, barberData);
            } else {
                const barberSnap = await getDoc(barberRef);
                if (!barberSnap.exists()) {
                    await setDoc(barberRef, barberData);
                }
            }
        }

        // Seed Services
        for (const service of services) {
            const serviceDocId = `${service.id}_${barbershopId}`;
            const serviceRef = doc(db, "services", serviceDocId);
            const serviceData = { ...service, id: serviceDocId, barbershopId };

            if (force) {
                await setDoc(serviceRef, serviceData);
            } else {
                const serviceSnap = await getDoc(serviceRef);
                if (!serviceSnap.exists()) {
                    await setDoc(serviceRef, serviceData);
                }
            }
        }

        // Seed Config
        const configRef = doc(db, "config", `settings_${barbershopId}`);
        const configData = { ...config, barbershopId };

        if (force) {
            await setDoc(configRef, configData);
        } else {
            const configSnap = await getDoc(configRef);
            if (!configSnap.exists()) {
                await setDoc(configRef, configData);
            }
        }

        console.log(`Sincronização para ${barbershopId} concluida com sucesso!`);
    } catch (error) {
        console.error(`Erro na sincronização para ${barbershopId}:`, error);
        throw error;
    }
};
